module.exports = __webpack_public_path__ + "img/node_level1.d45d70e1.png";